module.exports = __webpack_public_path__ + "img/tips_icon.5011375e.png";